import { useState } from 'react';

import { usePolls } from '../api/hooks.js';
import { useCan, useCurrentUser } from '../auth.js';
import { EmptyState, ErrorState, Loading, LoginPrompt } from '../components/states.js';
import { PollCard } from '../components/PollCard.js';
import { PollEditor } from '../components/PollEditor.js';

export function PollsPage() {
  const user = useCurrentUser();
  const canEdit = useCan('edit_polls');
  const [creating, setCreating] = useState(false);

  const active = usePolls('active', Boolean(user));
  const past = usePolls('past', Boolean(user));

  if (!user) {
    return (
      <div>
        <div className="page-head">
          <p className="eyebrow mb-1">The league</p>
          <h1 className="page-title">Polls</h1>
        </div>
        <LoginPrompt>Log in to vote in league polls and see the results.</LoginPrompt>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow mb-1">The league</p>
          <h1 className="page-title">Polls</h1>
        </div>
        {canEdit ? (
          <button type="button" className="btn-primary" onClick={() => setCreating(true)}>
            New poll
          </button>
        ) : null}
      </div>

      {active.error ? <ErrorState error={active.error} action="Log in to see polls." /> : null}

      <section className="mb-10">
        <h2 className="section-title mb-3">Open</h2>
        {active.isPending ? <Loading /> : null}
        {active.data?.length === 0 ? <EmptyState>No polls are open right now.</EmptyState> : null}
        <div className="grid gap-5 xl:grid-cols-2">
          {active.data?.map((poll) => (
            <PollCard key={poll.id} poll={poll} />
          ))}
        </div>
      </section>

      <section>
        <h2 className="section-title mb-3">Closed</h2>
        {past.isPending ? <Loading /> : null}
        {past.data?.length === 0 ? <EmptyState>No polls have been closed yet.</EmptyState> : null}
        <div className="grid gap-5 xl:grid-cols-2">
          {past.data?.map((poll) => (
            <PollCard key={poll.id} poll={poll} />
          ))}
        </div>
      </section>

      {creating ? <PollEditor onClose={() => setCreating(false)} /> : null}
    </div>
  );
}
